/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locallogin_Unexpectederror2Inputs */

const en_locallogin_unexpectederror2 = /** @type {(inputs: Locallogin_Unexpectederror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An unexpected error occurred`)
};

/**
* | output |
* | --- |
* | "An unexpected error occurred" |
*
* @param {Locallogin_Unexpectederror2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const locallogin_unexpectederror2 = /** @type {((inputs?: Locallogin_Unexpectederror2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locallogin_Unexpectederror2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_locallogin_unexpectederror2(inputs)
});
export { locallogin_unexpectederror2 as "localLogin_unexpectedError" }